export default __webpack_public_path__ + "static/media/wolf-min.c66f9dad.jpg";